module.exports = __webpack_public_path__ + "static/gatku-2-321c9d8151e84050d2516ab3353f58cd.jpg";